// extracted by mini-css-extract-plugin
module.exports = {"product-card":"container_product-card__Eu2xc","container":"container_container__nHyh4"};